import React from "react"
import { Col, Container, Row } from "react-bootstrap"
import { useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"

const Featured = () => {
  const {
    contentfulLogos: { logos },
  } = useStaticQuery(graphql`
    {
      contentfulLogos(contentful_id: { eq: "1SsCTHQWbSbt2j8sR4PQ0l" }) {
        logos {
          fluid {
            ...GatsbyContentfulFluid
          }
        }
      }
    }
  `)

  return (
    <section
      className="featured py-5 border-powder"
      style={{ borderTop: "2px dashed", borderBottom: "2px dashed" }}
    >
      <Container>
        <h4
          style={{ whiteSpace: "nowrap" }}
          className="text-center pb-3 my-auto"
        >
          <u>Featured in:</u>
        </h4>
        <Row className="align-items-center justify-content-center">
          {logos.length &&
            logos.map(({ fluid }, index) => (
              <Col xs={2} key={index} className="px-md-4 px-lg-5">
                <Image fluid={fluid} />
              </Col>
            ))}
        </Row>
      </Container>
    </section>
  )
}

export default Featured
